export const locale = {
  links: {
    messages: 'Messages',
    profile: 'Profile & Settings',
    forms: 'Forms',
  },
  open_dropdown: 'Open profile menu',
};
